// Throttle and debounce utility functions
export const throttle = (func, limit) => {
    let lastRan = 0;
    let lastFunc = null;
    
    const throttled = function(...args) {
      const context = this;
      const now = Date.now();
      
      if (now - lastRan >= limit) {
        func.apply(context, args);
        lastRan = now;
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(() => {
          if (Date.now() - lastRan >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (now - lastRan));
      }
    };
    
    throttled.cancel = function() {
      clearTimeout(lastFunc);
      lastRan = 0;
    };
    
    return throttled;
  };
  
  export const debounce = (func, delay) => {
    let timerId = null;
    
    const debounced = function(...args) {
      const context = this;
      clearTimeout(timerId);
      
      timerId = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
    
    // Add cancel method to the debounced function
    debounced.cancel = function() {
      clearTimeout(timerId);
      timerId = null;
    };
    
    return debounced;
  };
  
  // Utility to detect if the browser tab is visible
  export const isTabVisible = () => {
    return document.visibilityState === 'visible';
  };
  
  // Improved requestAnimationFrame that respects visibility and has cancellation
  export const rafThrottle = (callback) => {
    let rafId = null;
    let lastArgs = null;
    
    const throttledRaf = function(...args) {
      lastArgs = args;
      
      if (rafId === null) {
        rafId = requestAnimationFrame(() => {
          rafId = null;
          if (isTabVisible()) {
            callback.apply(this, lastArgs);
          }
        });
      }
    };
    
    throttledRaf.cancel = function() {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    };
    
    return throttledRaf;
  };